import config from '../config';

/**
 * dummy/real API 모듈 중 하나를 환경 설정에 따라 선택합니다.
 * USE_DUMMY=true  → dummy 모듈 사용
 * USE_DUMMY=false → real 모듈 사용
 */
export const createApi = (dummy, real) => config.USE_DUMMY ? dummy : real;
